export default __webpack_public_path__ + "static/media/b11.ccba2668.jpg";